exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#spin {\n  display: none;\n}\n#forgot-password {\n  background-color: transparent;\n  border: 0;\n  color: #302c2d;\n  font-size: 0.9rem;\n  outline: none;\n  transition: all 0.3s;\n}\n#forgot-password:hover {\n  color: #6f39ff;\n  transition: all 0.3s;\n}\n@media screen and (max-width: 768px) {\n#forgot-password {\n    margin-bottom: 15px;\n}\n}\n", ""]);

// exports
